changeUserAccountPlanTypeSetData